import React from 'react';
import styles from './CloseButton.module.scss';

interface CloseButtonProps {
  onDismiss: () => void;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onDismiss }) => {
  return (
    <button
      type="button"
      className={styles.customCloseButton}
      onClick={onDismiss}
      aria-label="Close"
    >
      <img
        src="/images/icons/solvize-close.svg"
        alt="Close"
        className={`${styles.icon} ${styles.defaultIcon}`}
      />
      <img
        src="/images/icons/solvize-close-filled.svg"
        alt="Close"
        className={`${styles.icon} ${styles.hoverIcon}`}
      />
    </button>
  );
};

export default CloseButton;
